<template>
  <el-form
    :model="ruleForm"
    :rules="rules"
    ref="ruleForm"
    label-width="81px"
    class="enterprise-rule"
    v-loading="formLoad"
  >
    <div class="box-title">
      <div class="box-title-code">
        企业基本信息
        <el-popover
          placement="bottom-start"
          width="240"
          trigger="hover">
          <div class="boxTitleCode" style="text-align:center">微信扫码预览</div>
          <img :src="companyCode" alt="" width="85%" style="margin-left: 19px;">
          <div slot="reference">
            <img :src="require('$img/loginr-code.png')" alt="" width="16px" height="16px">
            <span>预览和分享</span>           
          </div>
        </el-popover>
      </div> 
      <div style="font-size: 12px;color: #D84438;font-weight: 400;">如需修改企业名称、税号等信息，请联系客服</div>
    </div>
    <el-form-item label="企业全称" prop="name">
      <el-input class="input-width" v-model="ruleForm.name" :disabled="true"></el-input>
    </el-form-item>
    <el-form-item label="企业税号" prop="tax_no">
      <el-input class="input-width" v-model="ruleForm.tax_no" :disabled="true"></el-input>
    </el-form-item>
    <el-form-item label="企业简称" prop="short_name">
      <el-input class="input-width" :disabled="true" placeholder="" v-model="ruleForm.short_name" :maxlength="10"></el-input>
    </el-form-item>
    <el-form-item label="企业地址" required>       <!--prop="address" -->
      <!-- <el-input :maxlength="50" class="input-width" v-model="ruleForm.address"></el-input> -->
      <div class="address">
        <el-form-item prop="province" required>
          <el-select v-model="ruleForm.province" filterable placeholder="省份（必选）" @change="chosePro">
            <el-option
              v-for="(item,index) in provinceOps"
              :key="index"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="city_id" required>
          <el-select v-model="ruleForm.city_id" filterable placeholder="城市（必选）" @change="choseCity">
            <el-option
              v-for="(item,index) in cityOps"
              :key="index"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="area_name">
          <el-select v-model="ruleForm.area_name" filterable placeholder="区域（可选）" @change="choseArea">
            <el-option
              v-for="(item,index) in areaOps"
              :key="index"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="plate_id">
          <el-select v-model="ruleForm.plate_id" filterable placeholder="板块（可选）" @change="chosePlate">
            <el-option
              v-for="(item,index) in plateOps"
              :key="index"
              :label="item.plate_name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <el-input type="input" placeholder="请填写企业地址" v-model="ruleForm.address" :maxlength="100" show-word-limit style="width:430px"></el-input>
    </el-form-item>
    <el-form-item label="人员规模" prop="staff_size">
      <el-select class="input-width" v-model="ruleForm.staff_size" placeholder="请选择">
        <el-option label="0-20人" value="0-20人"></el-option>
        <el-option label="20-99人" value="20-99人"></el-option>
        <el-option label="100-499人" value="100-499人"></el-option>
        <el-option label="500-999人" value="500-999人"></el-option>
        <el-option label="1000-9999人" value="1000-9999人"></el-option>
        <el-option label="10000人以上" value="10000人以上"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="LOGO" prop="logo">
      <el-upload
        class="avatar-uploader"
        :action="`${httpUrl}/recruitment/file/upload`"
        :data='{type: 4}'
        :headers='headerStr'
        :show-file-list="false"
        name='file'
        v-loading='updateLoading'
        :on-success="handleAvatarSuccess"
        :on-error='updateError'
        :before-upload="beforeAvatarUpload">
        <img v-if="logoUrl" :src="logoUrl" class="avatar">
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
      <div class="ts-txt">格式png/jpg/jpge，大小在500kb以内</div>
    </el-form-item>
    <div class="box-title" style="margin-bottom:8px;margin-top:0">
      企业介绍
    </div>
    <el-form-item label="公司介绍" prop="remark">
      <el-input type="textarea" class="textarea-box" :maxlength="3000" v-model="ruleForm.remark" autosize show-word-limit></el-input>
    </el-form-item>
    <el-form-item>
      <el-button :loading="submitLoading" type="primary" @click="submitForm('ruleForm')">保存</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import Cookies from 'js-cookie'

export default {
  data() {
    return {
      ruleForm: {
        name: '',
        tax_no: '',
        short_name: '',
        staff_size: '',
        remark: '',
        province:'',
        city_id:'',
        area_name:'',
        plate_id:'',
        city_name:'',
        plate_name:''
      },
      companyCode:'',
      //企业地址
      provinceOps: [{
          value: '选项1',
          label: '黄金糕'
      }],
      cityOps: [],
      areaOps: [],
      plateOps: [],
      rules: {
        name: [
          { required: true, message: '请输入企业全称', trigger: 'blur' }
        ],
        tax_no: [
          { required: true, message: '请输入企业税号', trigger: 'blur' }
        ],
        // short_name: [
        //   { required: true, message: '请输入企业简称', trigger: 'blur' }
        // ],
        staff_size: [
          { required: true, message: '请选择企业人员规模', trigger: 'change' }
        ],
        province:[
          { required: true, message: '请选择省份', trigger: 'change' },
        ],
        city_id:[
          { required: true, message: '请选择城市', trigger: 'change' },
        ],
      },
      logoUrl: '',
      updateLoading: false,
      formLoad: false,
      sortNameDis: false,
      submitLoading: false,
      provinceOps: [],
      cityOps: [],
      areaOps: [],
      plateOps: [],
      provinceCity:[],//所有省市集合
      provinceArea:[],//所有区域集合
    }
  },
  mounted () {
    this.getCompanyInfo()
  },
  computed: {
    headerStr () {
      return {
        token: Cookies.get('pc_token') || '',
        version: process.env.VUE_APP_VERSION
      }
    },
    httpUrl () {
      return process.env.VUE_APP_API_URL
    }
  },
  methods: {
    getCompanyInfo () {
      this.formLoad = true
      this.$axios.post('/recruitment/company/info').then(res => {
        let da = res.data.company
        this.ruleForm = da
        this.logoUrl = da.logo
        if (da.short_name !== '') {
          this.sortNameDis = true
        }
        let parme={
          type:1
        }
        this.$axios.post('/recruitment/config/province_city',parme).then(resd => {
            this.provinceCity=resd.data.items
            for(let i=0;i<this.provinceCity.length;i++){
                if(this.provinceCity[i].province){
                    this.provinceOps.push(this.provinceCity[i].province)
                }
            }
            this.provinceOps=Array.from(new Set(this.provinceOps))     
            if(this.provinceCity.length>0){
              for(let i=0;i<this.provinceCity.length;i++){
                  if(this.provinceCity[i].province==res.data.company.province){
                      this.cityOps=this.provinceCity[i].city_list
                  }
              }
            }
            this.$axios.post('/recruitment/config/area_plate?id='+res.data.company.city_id).then(resr => {
              this.provinceArea=resr.data.items
              let arr=[]
              for(let i=0;i<this.provinceArea.length;i++){
                  if(this.provinceArea[i].area){
                      arr.push(this.provinceArea[i].area)
                  }
              }
              this.areaOps=arr
              if(this.provinceArea.length>0){
                for(let i=0;i<this.provinceArea.length;i++){
                  if(this.provinceArea[i].area==res.data.company.area){
                      this.plateOps=this.provinceArea[i].plate_list
                  }
                }
                this.ruleForm.plate_id=this.plateOps.length>0?this.plateOps.find(item=>item.plate_name==res.data.company.plate).id:"";
             }
            }) 
            // this.choseArea(res.data.company.area);
            this.ruleForm.province=res.data.company.province
            this.ruleForm.city_id=res.data.company.city_id
            this.ruleForm.city_name=res.data.company.city
            this.ruleForm.area_name=res.data.company.area
            // this.ruleForm.plate_id=res.data.company.plate
            this.ruleForm.plate_name=res.data.company.plate
            
            this.ruleForm.address=res.data.company.address    
        })
      }).finally(() => {
        this.formLoad = false
      })
      this.$axios.post('/recruitment/company/qrcode').then(res => {
        this.companyCode=res.data.img
      }).finally(() => {
        this.formLoad = false
      })
    },
    submitForm(formName) {
      this.submitLoading = true
      this.$refs[formName].validate(valid => {
        console.log(this.ruleForm)
        if (valid) {
          let dataSend = {
            staff_size: this.ruleForm.staff_size,
            remark: this.ruleForm.remark,
            logo: this.logoUrl,
            city_id: this.ruleForm.city_id,
            area_name: this.ruleForm.area_name,
            plate_id: this.ruleForm.plate_id,
            address: this.ruleForm.address,
          }
          if (!this.sortNameDis) {
            dataSend.short_name = this.ruleForm.short_name
          }
          this.$axios.post('/recruitment/company/edit_info', dataSend).then(() => {
            this.$message({
              message: '保存企业信息成功',
              type: 'success'
            })

            this.getCompanyInfo()
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          this.submitLoading = false
          return false
        }
      })
    },
    chosePro(e){
      //选择省份同时置空
      this.cityOps=[]
      this.ruleForm.city_id=''
      this.areaOps=[]
      this.ruleForm.area_name=''
      this.plateOps=[]
      this.ruleForm.plate_id=''
      this.ruleForm.city_name=''
      this.ruleForm.plate_name=''
      if(this.provinceCity.length>0){
          for(let i=0;i<this.provinceCity.length;i++){
              if(this.provinceCity[i].province==e){
                  this.cityOps=this.provinceCity[i].city_list
              }
          }
      }
    },
    choseCity(e){
      // if(this.status==1)this.ruleForm.city_name=this.cityOps.find(item=>item.id==e).name;
      this.areaOps=[]
      this.ruleForm.area_name=''
      this.plateOps=[]
      this.ruleForm.plate_id=''
      this.ruleForm.plate_name=''
      this.$axios.post('/recruitment/config/area_plate?id='+e).then(res => {
          this.provinceArea=res.data.items
          let arr=[]
          for(let i=0;i<this.provinceArea.length;i++){
              if(this.provinceArea[i].area){
                  arr.push(this.provinceArea[i].area)
              }
          }
          this.areaOps=arr
          console.log(this.areaOps)
      })
    },
    choseArea(e){
      this.plateOps=[]
      this.ruleForm.plate_id=''
      this.ruleForm.plate_name=''
      if(this.provinceArea.length>0){
          for(let i=0;i<this.provinceArea.length;i++){
              if(this.provinceArea[i].area==e){
                  this.plateOps=this.provinceArea[i].plate_list
              }
          }
      }
    },
    chosePlate(e){
      this.$forceUpdate();
      this.ruleForm.plate_name=this.plateOps.find(item=>item.id==e).plate_name;
    },
    updateError () {
      this.updateLoading = false
    },
    handleAvatarSuccess(res) {
      this.updateLoading = false
      this.logoUrl = res.data.file.url
    },
    beforeAvatarUpload(file) {
      this.updateLoading = true
      const isJPG = ['image/png', 'image/jpg', 'image/jpeg'].includes(file.type)
      const isLt2M = file.size / 1024 < 500;

      if (!isJPG) {
        this.updateLoading = false
        this.$message.error('上传图片只能是 JPG、JPEG、PNG格式!');
      }
      if (!isLt2M) {
        this.updateLoading = false
        this.$message.error('图片请控制在500kb以内');
      }

      return isJPG && isLt2M;
    },    
  }
}
</script>

<style lang='scss'>
.enterprise-rule{
  width: 100%;
  .el-form-item{
    // margin-bottom: 14px;
  }
  .el-icon-loading:before {
    font-size: 12px!important;
  }
  .box-title{
    color: #3C4554;
    font-size: 20px;
    // margin-top: 20px;
    margin-bottom: 16px;
    font-weight: 600;   
    .box-title-code{
      display: flex;
      img{
        margin:0 2px 0 30px;
        position: relative;
        top: 3px;
        cursor: pointer;
      }
      span{
        color:#4061F8;
        font-size: 14px;
        cursor: pointer;
      }
      .boxTitleCode{
        color:#5E5E5E;
        font-size: 13px;
        text-align: center;
      }
      .el-popover__reference{
        margin-top: 3px;
      }
    }
    
  }

  .input-width{
    width: 430px;
  }

  .textarea-box{
    width: 932px;

    textarea{
      min-height: 113px !important;
    }
  }

  .avatar-uploader{
    height: 100px;
    width: 100px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }

  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }

  .ts-txt{
    color: #808080;
    font-size: 14px;
  }
  .address{
    display:flex;
    margin-bottom:20px;
    width: 430px;
    .el-form-item{
      margin-left: 5px; 
    }
    .el-form-item:first-child{
      margin-left: 0px;    
    }
  }
}
</style>
